import React from "react"
import { CrossOutline } from "@cleartrip/bento-icons/src/components/Icons"

function ModalHeader({ onClose, children, closeButton }) {
  function handleClose(e) {
    onClose() && onClose(e)
  }
  
  return (
    <div className="px-8 py-6 flex flex-between flex-middle">
      <p className="fs-7 fw-600 c-neutral-900">{children}</p>
      {closeButton && (
        <CrossOutline
          onClick={handleClose}
          height={32}
          width={32}
          className="c-pointer c-neutral-900"
        />
      )}
    </div>
  )
}

export default ModalHeader
